import Vue from 'vue'
import axios from 'axios'
import {router} from './router'
import {_} from 'vue-underscore'

export const store = Vue.observable({
  status: {
    ready: false,
    busy: false,
    error: false,
    dir_entry: true
  },
  params: {
    paging: {
      page: 1,
      ipp: 24
    },
    filters: {}
  },
  result: false
})

export const mutations = {
  filter (filter) {
    let exists = (filter.key in store.params.filters)
    if (filter.value !== null && filter.value != '' && filter.value !== undefined) {
      if (exists) {
        store.params.filters[filter.key] = filter.value
      } else {
        Vue.set(store.params.filters, filter.key, filter.value)
      }
    } else {
      if (exists) {
        Vue.delete(store.params.filters, filter.key)
      }
    }
  },
  filters (filters) {
    store.params.filters = filters
  },
  nextPage () {
    store.params.paging.page = store.params.paging.page + 1
    actions.getData()
  },
  page (page) {
    store.params.paging.page = Number(page)
  },
  result (result) {
    if (result === false) {
      store.result = false
    } else {
      if (store.params.paging.page == 1) {
        store.result = result 
      } else {
        store.result.items = store.result.items.concat(result.items)
      }
    }
  },
  status (key, value) {
    if (key in store.status) {
      store.status[key] = value
    }
  }
}

export const actions = {
  /** 
   * Initialise app
   */
  setup (config) {
    store.config = config
  },
  getData (reset) {
    if (!store.status.busy) {
      if (reset) {
        mutations.page(1)
        mutations.result(false)
      }

      const options = {
        method: 'post',
        data: {
          action: 'providers',
          params: store.params
        }
      }

      mutations.status('busy', true)
      actions.sendRequest(options)
      .then(function (response) {
        if (response.data.success) {
          actions.updateURL()
          mutations.result(response.data.result)
        } else {
          mutations.status('error', response.data.message)
        }
      }.bind(this)).catch(function (error) {
        mutations.status('error', error)
      }.bind(this)).finally(function () {
        mutations.status('busy', false)
      }.bind(this))
    }
  },
  /** 
   * Update the browser url
   */
  updateURL () {
    let q = {}
    const config_filters = store.config.filters

    _.each(store.params.filters, function(filter_value, index) {
      let config_filter = _.find(config_filters, function(filter) {
        return filter.name == index
      })

      if (config_filter) {
        let val
        if (filter_value && filter_value.length != 0) {
          if (Array.isArray(filter_value)) {
            val = JSON.stringify(filter_value)
          } else {
            val = filter_value
          }
          q[config_filter.url_param] = val
        }
      }
    })
    router.replace({ path: '/providers', query: q }).catch(()=>{})
  },
  checkForQuery (query) {
    if (!_.isEmpty(query)) {

      const config_filters = store.config.filters
      const user_filters = {}

      _.each(query, function(value, param) {
        let config_filter = _.find(config_filters, function(filter) {
          return filter.url_param == param
        })
        
        if (config_filter) {
          let san_val = null
          switch (config_filter.type) {
            case 'array':
              san_val = JSON.parse(value)
              break
            case 'string':
              san_val = value.replace(/[^\w\s]/gi, '')
              break
            case 'number':
              san_val = parseInt(value)
              break
          }

          if (san_val) {
            user_filters[config_filter.name] = san_val
          }
        }
      })

      if (!_.isEmpty(user_filters)) {
        mutations.filters(user_filters)
      }
    }
    return true
  },
  /**
   * Send http request
   * @param object options
   * @return object promise
   */
  sendRequest (options) {
    const request = {
      method: options.method,
      url: store.config.url,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: 'data' in options ? options.data : null,
      responseType: 'json'
    }

    return axios.request(request)
  }
}